import { BaseSymbol } from '@ui/assets/config/trade-pair-listings';
import { useIsMounted } from '@ui/hooks/useIsMounted';
import { getLocalStorageKey } from '@ui/utils/getLocalStorageKey';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type TradePairWatchListStore = {
  watchList: BaseSymbol[];
  useCurrentWatchList: () => BaseSymbol[];
  addToWatchList: (baseSymbol: BaseSymbol) => void;
  removeFromWatchList: (baseSymbol: BaseSymbol) => void;
  clearWatchList: () => void;
};

export const useTradePairWatchListStore = create<TradePairWatchListStore>()(
  persist(
    (set, get) => ({
      watchList: [],

      useCurrentWatchList: () => {
        const isMount = useIsMounted();

        return isMount ? get().watchList : [];
      },

      addToWatchList: (baseSymbol: BaseSymbol) => {
        const { watchList } = get();
        if (!watchList.includes(baseSymbol)) {
          set({
            watchList: [...watchList, baseSymbol],
          });
        }
      },

      removeFromWatchList: (baseSymbol: BaseSymbol) => {
        const { watchList } = get();
        set({
          watchList: watchList.filter((item) => item !== baseSymbol),
        });
      },

      clearWatchList: () => {
        set({
          watchList: [],
        });
      },
    }),
    {
      version: 2,
      name: getLocalStorageKey('tradePair.watchList'),
    },
  ),
);
